import React, { useState, useEffect } from "react";
import Button from "../Button";
import UserList from "../../components/UserList";
import { BUTTON_CONSTANTS } from "../../constants";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// Shape of data props that are received:
//
// {
//   "exhaustiveNbHits": true,
//   "hits": [
//     {
//       "_highlightResult": {
//         "username": {
//           "fullyHighlighted": false,
//           "matchLevel": "full",
//           "matchedWords": [
//             "sam"
//           ],
//           "value": "<em>sam</em>sams"
//         }
//       },
//       "objectID": "tcmiEpUEbHh4oI2NR3ftxY8pUgC3",
//       "username": "samsams"
//     }
//   ],
//   "hitsPerPage": 20,
//   "nbHits": 1,
//   "nbPages": 1,
//   "page": 0,
//   "params": "query=sam",
//   "processingTimeMS": 1,
//   "query": "sam"
// }

const SearchResultsModal = props => {
  const [userResultData, setUserResultData] = useState([]);

  useEffect(() => {
    if (props.data && props.data.hits && props.data.hits.length) {
      setUserResultData(props.data.hits);
    }
  }, [props.data]);

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Search Results</ModalHeader>
      <ModalBody>
        <UserList data={userResultData} />
      </ModalBody>
      <ModalFooter>
        <Button
          buttonStyle={BUTTON_CONSTANTS.GREY_TO_NAVY}
          buttonText={"Cancel"}
          onClick={props.toggle}
        />
      </ModalFooter>
    </Modal>
  );
};

export default SearchResultsModal;
